import { useEffect } from "react";

/**
 * Lightweight document head manager — sets <title>, meta description,
 * canonical, OpenGraph + Twitter cards, and injects a JSON-LD <script> per route.
 */
export default function Seo({
  title,
  description = "Hand-finished fine jewelry, made by craft and worn by character. Glitterz SH Collection — London.",
  image = "https://images.unsplash.com/photo-1613966561243-c6959a886009?crop=entropy&cs=srgb&fm=jpg&q=85",
  type = "website",
  jsonLd = null,
  canonical = null,
}) {
  useEffect(() => {
    const SITE_TITLE = "Glitterz SH Collection | Elegant Jewelry Online UK";
    const fullTitle = title
      ? (/glitterz/i.test(title) ? title : `${title} | Glitterz SH Collection`)
      : SITE_TITLE;
    document.title = fullTitle;

    const set = (sel, attr, val) => {
      let tag = document.head.querySelector(sel);
      if (!tag) {
        tag = document.createElement(sel.startsWith("link") ? "link" : "meta");
        if (sel.startsWith('meta[name="')) tag.setAttribute("name", sel.match(/name="([^"]+)"/)[1]);
        else if (sel.startsWith('meta[property="')) tag.setAttribute("property", sel.match(/property="([^"]+)"/)[1]);
        else if (sel.startsWith('link[rel="')) tag.setAttribute("rel", sel.match(/rel="([^"]+)"/)[1]);
        document.head.appendChild(tag);
      }
      tag.setAttribute(attr, val);
    };

    set('meta[name="description"]', "content", description);
    set('meta[property="og:title"]', "content", fullTitle);
    set('meta[property="og:description"]', "content", description);
    set('meta[property="og:type"]', "content", type);
    set('meta[property="og:image"]', "content", image);
    set('meta[name="twitter:card"]', "content", "summary_large_image");
    set('meta[name="twitter:title"]', "content", fullTitle);
    set('meta[name="twitter:description"]', "content", description);
    set('meta[name="twitter:image"]', "content", image);
    if (canonical) set('link[rel="canonical"]', "href", canonical);

    let ld = document.getElementById("aura-jsonld");
    if (jsonLd) {
      if (!ld) {
        ld = document.createElement("script");
        ld.id = "aura-jsonld";
        ld.type = "application/ld+json";
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) {
      ld.textContent = "";
    }
  }, [title, description, image, type, jsonLd, canonical]);

  return null;
}
